import React from 'react';
import { useSelector } from 'react-redux';

// Types
import { ReviewTemplateTypeType } from 'Shared/types/ReviewTemplates.type';
import { FeedbackRecognitionTemplateTypes } from 'Shared/constants/types';

// Constants
import { defaultTemplates } from './DefaultFeedbackTemplates.constants';

// Utils
import { getReviewTemplateErrors } from 'Shared/utils/ReviewTemplate.utils';

// Hooks
import { useReviewTemplates } from 'Shared/utils/hooks/use-review-templates';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Components
import ReviewTemplateList from 'Shared/components/ReviewTemplateList/ReviewTemplateList';

// Styles
import './FeedbackTemplateSelect.scss';

type Props = {
  handleChooseTemplate: Function;
};

const FeedbackTemplateSelect = ({ handleChooseTemplate }: Props) => {
  const { id: currentUserId } = useCurrentUser();
  const { templates, isFetching } = useReviewTemplates({
    templateType: ReviewTemplateTypeType.feedback,
  });

  const hideStrengthsAndWeaknessesFeedbackTemplate = useSelector(
    state => state.organization?.hideStrengthsAndWeaknessesFeedbackTemplate
  );

  const filteredDefaultTemplates = hideStrengthsAndWeaknessesFeedbackTemplate
    ? defaultTemplates.filter(t => t.slug !== FeedbackRecognitionTemplateTypes.feedbackStrengthsOpportunitiesTemplate)
    : defaultTemplates;

  const filteredTemplates = templates.filter(template => {
    const hasErrors = getReviewTemplateErrors({ reviewTemplate: template }).length > 0;
    return !hasErrors || (hasErrors && currentUserId === template.userId);
  });

  if (isFetching && templates.length === 0) return <>loading...</>;

  return (
    <ReviewTemplateList
      reviewTemplates={[...filteredTemplates, ...filteredDefaultTemplates]}
      handleChooseTemplate={handleChooseTemplate}
    />
  );
};

export default FeedbackTemplateSelect;
